import React from 'react';

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  '@id': 'https://www.zola.com/#organization',
  name: 'Zola',
  url: 'https://www.zola.com',
  address: {
    '@type': 'PostalAddress',
    streetAddress: '250 Greenwich St, 39th Floor',
    addressLocality: 'New York',
    addressRegion: 'NY',
    postalCode: '10007',
    addressCountry: 'US',
  },
  logo: 'https://d1tntvpcrzvon2.cloudfront.net/static-assets/images/logos/zola-logomark-marine.svg',
  description:
    'From venues and save the dates to a free wedding website, a registry and even your cake — Zola is here for all the days along the way.',
  sameAs: [
    'https://www.facebook.com/zola',
    'https://www.pinterest.com/zola',
    'https://www.twitter.com/zola',
    'https://www.instagram.com/zola',
    'https://www.tiktok.com/@zola',
    'https://www.linkedin.com/company/zola-com/',
  ],
};

const renderOrganizationJsonLdScript = () => (
  <script type="application/ld+json">{JSON.stringify(orgSchema)}</script>
);

export default renderOrganizationJsonLdScript;
